// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: aTBS0RDzc9

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import MenuOption from "../../MenuOption"; // plasmic-import: adNwSWS9Ft/component
import OriginalLinkButton from "../../OriginalLinkButton"; // plasmic-import: oJPOUfnhGs/component
import SmallPlayButton from "../../SmallPlayButton"; // plasmic-import: wtfhNXcJNq/component
import Source from "../../Source"; // plasmic-import: U1WSll_dgG/component

import { ThemeValue, useTheme } from "./PlasmicGlobalVariant__Theme"; // plasmic-import: 40N_XXvhaC/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicContextMenu.module.css"; // plasmic-import: aTBS0RDzc9/css

import IconsOpenIcon from "./icons/PlasmicIcon__IconsOpen"; // plasmic-import: M4gp-x8W5R/icon
import TwitterFlatIcon from "./icons/PlasmicIcon__TwitterFlat"; // plasmic-import: 51ret1TjP/icon
import _27IcontwitterIcon from "./icons/PlasmicIcon___27Icontwitter"; // plasmic-import: OLUGpSl8i4I/icon
import IconsSourcesYoutubeIcon from "./icons/PlasmicIcon__IconsSourcesYoutube"; // plasmic-import: 9FfsM2N0XvJ/icon
import SpotifyLogoIcon from "./icons/PlasmicIcon__SpotifyLogo"; // plasmic-import: 7r3Uzwe2O/icon
import IconsShareIcon from "./icons/PlasmicIcon__IconsShare"; // plasmic-import: c8IgV_oMidb/icon
import IconsReadAloudIcon from "./icons/PlasmicIcon__IconsReadAloud"; // plasmic-import: -n-EEm7hMV/icon
import DarkPlaylistIconNextsvgIcon from "./icons/PlasmicIcon__DarkPlaylistIconNextsvg"; // plasmic-import: QSBMaMULT/icon
import DarkPlaylistIconLastsvgIcon from "./icons/PlasmicIcon__DarkPlaylistIconLastsvg"; // plasmic-import: g9uRBfw4P/icon
import IconsSourcesSavedForLaterIcon from "./icons/PlasmicIcon__IconsSourcesSavedForLater"; // plasmic-import: sGge8vvbDB/icon
import ArchiveIcon2Icon from "./icons/PlasmicIcon__ArchiveIcon2"; // plasmic-import: ANIefIZP8/icon
import IconsDelete2Icon from "./icons/PlasmicIcon__IconsDelete2"; // plasmic-import: zabXt4Zpyv/icon

createPlasmicElementProxy;

export type PlasmicContextMenu__VariantMembers = {
  type: "websites" | "twitter" | "youtube" | "spotify";
  expanded: "websites" | "twitter" | "youtube" | "spotify";
  hidden: "hidden";
  hideArchiveButton: "hideArchiveButton";
  hideSource: "hideSource";
};
export type PlasmicContextMenu__VariantsArgs = {
  type?: SingleChoiceArg<"websites" | "twitter" | "youtube" | "spotify">;
  expanded?: SingleChoiceArg<"websites" | "twitter" | "youtube" | "spotify">;
  hidden?: SingleBooleanChoiceArg<"hidden">;
  hideArchiveButton?: SingleBooleanChoiceArg<"hideArchiveButton">;
  hideSource?: SingleBooleanChoiceArg<"hideSource">;
};
type VariantPropType = keyof PlasmicContextMenu__VariantsArgs;
export const PlasmicContextMenu__VariantProps = new Array<VariantPropType>(
  "type",
  "expanded",
  "hidden",
  "hideArchiveButton",
  "hideSource"
);

export type PlasmicContextMenu__ArgsType = {
  title?: React.ReactNode;
};
type ArgPropType = keyof PlasmicContextMenu__ArgsType;
export const PlasmicContextMenu__ArgProps = new Array<ArgPropType>("title");

export type PlasmicContextMenu__OverridesType = {
  menuContainer?: p.Flex<"div">;
  menu?: p.Flex<"div">;
  showMoreButton?: p.Flex<typeof MenuOption>;
  icon3?: p.Flex<"svg">;
  expandedStack?: p.Flex<"div">;
  titleContainer?: p.Flex<"div">;
  author?: p.Flex<"div">;
  date?: p.Flex<"div">;
  publishedDate?: p.Flex<"div">;
  by?: p.Flex<"div">;
  openOriginalLinkButtonForWebsites?: p.Flex<"div">;
  originalLinkButton?: p.Flex<typeof OriginalLinkButton>;
  icon4?: p.Flex<"svg">;
  smallPlayButton?: p.Flex<typeof SmallPlayButton>;
  source?: p.Flex<typeof Source>;
  sourceTitle?: p.Flex<"div">;
  sourceHandle?: p.Flex<"div">;
  sourceDescription?: p.Flex<"div">;
  openOriginalLinkButton?: p.Flex<typeof MenuOption>;
  icon?: p.Flex<"svg">;
  icon11?: p.Flex<"svg">;
  readAloudButton?: p.Flex<typeof MenuOption>;
  icon5?: p.Flex<"svg">;
  playNextButton?: p.Flex<typeof MenuOption>;
  icon6?: p.Flex<"svg">;
  playLaterButton?: p.Flex<typeof MenuOption>;
  icon7?: p.Flex<"svg">;
  saveForLaterButton?: p.Flex<typeof MenuOption>;
  icon8?: p.Flex<"svg">;
  archiveButton?: p.Flex<typeof MenuOption>;
  icon9?: p.Flex<"svg">;
  removeButton?: p.Flex<typeof MenuOption>;
};

export interface DefaultContextMenuProps {
  title?: React.ReactNode;
  type?: SingleChoiceArg<"websites" | "twitter" | "youtube" | "spotify">;
  expanded?: SingleChoiceArg<"websites" | "twitter" | "youtube" | "spotify">;
  hidden?: SingleBooleanChoiceArg<"hidden">;
  hideArchiveButton?: SingleBooleanChoiceArg<"hideArchiveButton">;
  hideSource?: SingleBooleanChoiceArg<"hideSource">;
  className?: string;
}

const $$ = {};

function PlasmicContextMenu__RenderFunc(props: {
  variants: PlasmicContextMenu__VariantsArgs;
  args: PlasmicContextMenu__ArgsType;
  overrides: PlasmicContextMenu__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "expanded",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.expanded
      },
      {
        path: "hidden",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.hidden
      },
      {
        path: "type",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.type
      },
      {
        path: "hideArchiveButton",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) =>
          $props.hideArchiveButton
      },
      {
        path: "hideSource",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.hideSource
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const globalVariants = ensureGlobalVariants({
    theme: useTheme()
  });

  return (
    <div
      data-plasmic-name={"menuContainer"}
      data-plasmic-override={overrides.menuContainer}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.menuContainer,
        {
          [projectcss.global_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          ),
          [sty.menuContainerexpanded_spotify]: hasVariant(
            $state,
            "expanded",
            "spotify"
          ),
          [sty.menuContainerexpanded_twitter]: hasVariant(
            $state,
            "expanded",
            "twitter"
          ),
          [sty.menuContainerexpanded_websites]: hasVariant(
            $state,
            "expanded",
            "websites"
          ),
          [sty.menuContainerexpanded_youtube]: hasVariant(
            $state,
            "expanded",
            "youtube"
          ),
          [sty.menuContainerhidden]: hasVariant($state, "hidden", "hidden"),
          [sty.menuContainertype_twitter]: hasVariant(
            $state,
            "type",
            "twitter"
          ),
          [sty.menuContainertype_websites]: hasVariant(
            $state,
            "type",
            "websites"
          )
        }
      )}
    >
      <div
        data-plasmic-name={"menu"}
        data-plasmic-override={overrides.menu}
        className={classNames(projectcss.all, sty.menu, {
          [sty.menuexpanded_spotify]: hasVariant($state, "expanded", "spotify"),
          [sty.menuexpanded_twitter]: hasVariant($state, "expanded", "twitter"),
          [sty.menuexpanded_websites]: hasVariant(
            $state,
            "expanded",
            "websites"
          ),
          [sty.menuexpanded_youtube]: hasVariant($state, "expanded", "youtube"),
          [sty.menuhidden]: hasVariant($state, "hidden", "hidden"),
          [sty.menutype_twitter]: hasVariant($state, "type", "twitter"),
          [sty.menutype_websites]: hasVariant($state, "type", "websites")
        })}
        id={"context-menu"}
      >
        {(
          hasVariant($state, "expanded", "spotify")
            ? false
            : hasVariant($state, "expanded", "youtube")
            ? false
            : hasVariant($state, "expanded", "twitter")
            ? false
            : hasVariant($state, "expanded", "websites")
            ? false
            : true
        ) ? (
          <MenuOption
            data-plasmic-name={"showMoreButton"}
            data-plasmic-override={overrides.showMoreButton}
            className={classNames("__wab_instance", sty.showMoreButton, {
              [sty.showMoreButtonexpanded_spotify]: hasVariant(
                $state,
                "expanded",
                "spotify"
              ),
              [sty.showMoreButtonexpanded_twitter]: hasVariant(
                $state,
                "expanded",
                "twitter"
              ),
              [sty.showMoreButtonexpanded_websites]: hasVariant(
                $state,
                "expanded",
                "websites"
              ),
              [sty.showMoreButtonexpanded_youtube]: hasVariant(
                $state,
                "expanded",
                "youtube"
              ),
              [sty.showMoreButtonhidden]: hasVariant(
                $state,
                "hidden",
                "hidden"
              ),
              [sty.showMoreButtontype_twitter]: hasVariant(
                $state,
                "type",
                "twitter"
              ),
              [sty.showMoreButtontype_websites]: hasVariant(
                $state,
                "type",
                "websites"
              ),
              [sty.showMoreButtontype_youtube]: hasVariant(
                $state,
                "type",
                "youtube"
              )
            })}
            icon={
              <div className={classNames(projectcss.all, sty.freeBox__nsHhs)}>
                <IconsOpenIcon
                  data-plasmic-name={"icon3"}
                  data-plasmic-override={overrides.icon3}
                  className={classNames(projectcss.all, sty.icon3, {
                    [sty.icon3type_youtube]: hasVariant(
                      $state,
                      "type",
                      "youtube"
                    )
                  })}
                  role={"img"}
                />
              </div>
            }
            title={"Show more"}
          />
        ) : null}
        <p.Stack
          as={"div"}
          data-plasmic-name={"expandedStack"}
          data-plasmic-override={overrides.expandedStack}
          hasGap={true}
          className={classNames(projectcss.all, sty.expandedStack, {
            [sty.expandedStackexpanded_spotify]: hasVariant(
              $state,
              "expanded",
              "spotify"
            ),
            [sty.expandedStackexpanded_twitter]: hasVariant(
              $state,
              "expanded",
              "twitter"
            ),
            [sty.expandedStackexpanded_websites]: hasVariant(
              $state,
              "expanded",
              "websites"
            ),
            [sty.expandedStackexpanded_youtube]: hasVariant(
              $state,
              "expanded",
              "youtube"
            )
          })}
        >
          <div
            className={classNames(projectcss.all, sty.freeBox__bspMe, {
              [sty.freeBoxexpanded_spotify__bspMeIn6M]: hasVariant(
                $state,
                "expanded",
                "spotify"
              ),
              [sty.freeBoxexpanded_twitter__bspMePLf1K]: hasVariant(
                $state,
                "expanded",
                "twitter"
              ),
              [sty.freeBoxexpanded_websites__bspMeJcYhO]: hasVariant(
                $state,
                "expanded",
                "websites"
              ),
              [sty.freeBoxexpanded_youtube__bspMeCGgNx]: hasVariant(
                $state,
                "expanded",
                "youtube"
              )
            })}
          >
            <div
              data-plasmic-name={"titleContainer"}
              data-plasmic-override={overrides.titleContainer}
              className={classNames(projectcss.all, sty.titleContainer, {
                [sty.titleContainerexpanded_spotify]: hasVariant(
                  $state,
                  "expanded",
                  "spotify"
                ),
                [sty.titleContainerexpanded_twitter]: hasVariant(
                  $state,
                  "expanded",
                  "twitter"
                ),
                [sty.titleContainerexpanded_websites]: hasVariant(
                  $state,
                  "expanded",
                  "websites"
                ),
                [sty.titleContainerexpanded_youtube]: hasVariant(
                  $state,
                  "expanded",
                  "youtube"
                )
              })}
            >
              {p.renderPlasmicSlot({
                defaultContents:
                  "Title Title Title Title Title Title Title Title Title Title Title Title Title Title Title",
                value: args.title,
                className: classNames(sty.slotTargetTitle, {
                  [sty.slotTargetTitleexpanded_spotify]: hasVariant(
                    $state,
                    "expanded",
                    "spotify"
                  ),
                  [sty.slotTargetTitleexpanded_twitter]: hasVariant(
                    $state,
                    "expanded",
                    "twitter"
                  ),
                  [sty.slotTargetTitleexpanded_websites]: hasVariant(
                    $state,
                    "expanded",
                    "websites"
                  ),
                  [sty.slotTargetTitleexpanded_youtube]: hasVariant(
                    $state,
                    "expanded",
                    "youtube"
                  )
                })
              })}
            </div>
            <div
              data-plasmic-name={"author"}
              data-plasmic-override={overrides.author}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.author,
                {
                  [sty.authorexpanded_spotify]: hasVariant(
                    $state,
                    "expanded",
                    "spotify"
                  ),
                  [sty.authorexpanded_twitter]: hasVariant(
                    $state,
                    "expanded",
                    "twitter"
                  ),
                  [sty.authorexpanded_websites]: hasVariant(
                    $state,
                    "expanded",
                    "websites"
                  ),
                  [sty.authorexpanded_youtube]: hasVariant(
                    $state,
                    "expanded",
                    "youtube"
                  )
                }
              )}
            >
              {"Author"}
            </div>
            <div
              data-plasmic-name={"date"}
              data-plasmic-override={overrides.date}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.date,
                {
                  [sty.dateexpanded_spotify]: hasVariant(
                    $state,
                    "expanded",
                    "spotify"
                  ),
                  [sty.dateexpanded_twitter]: hasVariant(
                    $state,
                    "expanded",
                    "twitter"
                  ),
                  [sty.dateexpanded_websites]: hasVariant(
                    $state,
                    "expanded",
                    "websites"
                  ),
                  [sty.dateexpanded_youtube]: hasVariant(
                    $state,
                    "expanded",
                    "youtube"
                  )
                }
              )}
            >
              {"Date"}
            </div>
          </div>
          <p.Stack
            as={"div"}
            hasGap={true}
            className={classNames(projectcss.all, sty.freeBox__mcZ1U, {
              [sty.freeBoxexpanded_spotify__mcZ1UIn6M]: hasVariant(
                $state,
                "expanded",
                "spotify"
              ),
              [sty.freeBoxexpanded_twitter__mcZ1UPLf1K]: hasVariant(
                $state,
                "expanded",
                "twitter"
              ),
              [sty.freeBoxexpanded_websites__mcZ1UJcYhO]: hasVariant(
                $state,
                "expanded",
                "websites"
              ),
              [sty.freeBoxexpanded_youtube__mcZ1UCGgNx]: hasVariant(
                $state,
                "expanded",
                "youtube"
              )
            })}
          >
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__gmscV, {
                [sty.freeBoxexpanded_spotify__gmscVIn6M]: hasVariant(
                  $state,
                  "expanded",
                  "spotify"
                ),
                [sty.freeBoxexpanded_twitter__gmscVpLf1K]: hasVariant(
                  $state,
                  "expanded",
                  "twitter"
                ),
                [sty.freeBoxexpanded_websites__gmscVJcYhO]: hasVariant(
                  $state,
                  "expanded",
                  "websites"
                ),
                [sty.freeBoxexpanded_youtube__gmscVcGgNx]: hasVariant(
                  $state,
                  "expanded",
                  "youtube"
                )
              })}
            >
              <p.Stack
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.freeBox__lGw3B, {
                  [sty.freeBoxexpanded_spotify__lGw3BIn6M]: hasVariant(
                    $state,
                    "expanded",
                    "spotify"
                  ),
                  [sty.freeBoxexpanded_twitter__lGw3BpLf1K]: hasVariant(
                    $state,
                    "expanded",
                    "twitter"
                  ),
                  [sty.freeBoxexpanded_websites__lGw3BJcYhO]: hasVariant(
                    $state,
                    "expanded",
                    "websites"
                  ),
                  [sty.freeBoxexpanded_youtube__lGw3BcGgNx]: hasVariant(
                    $state,
                    "expanded",
                    "youtube"
                  )
                })}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__nUwD,
                    {
                      [sty.textexpanded_spotify__nUwDIn6M]: hasVariant(
                        $state,
                        "expanded",
                        "spotify"
                      ),
                      [sty.textexpanded_twitter__nUwDPLf1K]: hasVariant(
                        $state,
                        "expanded",
                        "twitter"
                      ),
                      [sty.textexpanded_websites__nUwDJcYhO]: hasVariant(
                        $state,
                        "expanded",
                        "websites"
                      ),
                      [sty.textexpanded_youtube__nUwDCGgNx]: hasVariant(
                        $state,
                        "expanded",
                        "youtube"
                      )
                    }
                  )}
                >
                  {hasVariant($state, "expanded", "spotify")
                    ? "Published:"
                    : hasVariant($state, "expanded", "youtube")
                    ? "Published:"
                    : hasVariant($state, "expanded", "twitter")
                    ? "posted:"
                    : hasVariant($state, "expanded", "websites")
                    ? "Published:"
                    : "Published on:"}
                </div>
                <div
                  data-plasmic-name={"publishedDate"}
                  data-plasmic-override={overrides.publishedDate}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.publishedDate,
                    {
                      [sty.publishedDateexpanded_spotify]: hasVariant(
                        $state,
                        "expanded",
                        "spotify"
                      ),
                      [sty.publishedDateexpanded_twitter]: hasVariant(
                        $state,
                        "expanded",
                        "twitter"
                      ),
                      [sty.publishedDateexpanded_websites]: hasVariant(
                        $state,
                        "expanded",
                        "websites"
                      ),
                      [sty.publishedDateexpanded_youtube]: hasVariant(
                        $state,
                        "expanded",
                        "youtube"
                      )
                    }
                  )}
                >
                  {hasVariant($state, "expanded", "spotify")
                    ? "09.11.2001"
                    : hasVariant($state, "expanded", "youtube")
                    ? "09.11.2001"
                    : hasVariant($state, "expanded", "twitter")
                    ? "16.04.2022"
                    : hasVariant($state, "expanded", "websites")
                    ? "11.9.2021"
                    : "Published on:"}
                </div>
              </p.Stack>
              <div
                className={classNames(projectcss.all, sty.freeBox___0JPcX, {
                  [sty.freeBoxexpanded_spotify___0JPcXIn6M]: hasVariant(
                    $state,
                    "expanded",
                    "spotify"
                  ),
                  [sty.freeBoxexpanded_twitter___0JPcXpLf1K]: hasVariant(
                    $state,
                    "expanded",
                    "twitter"
                  ),
                  [sty.freeBoxexpanded_websites___0JPcXJcYhO]: hasVariant(
                    $state,
                    "expanded",
                    "websites"
                  ),
                  [sty.freeBoxexpanded_youtube___0JPcXcGgNx]: hasVariant(
                    $state,
                    "expanded",
                    "youtube"
                  )
                })}
              >
                <div
                  data-plasmic-name={"by"}
                  data-plasmic-override={overrides.by}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.by,
                    {
                      [sty.byexpanded_spotify]: hasVariant(
                        $state,
                        "expanded",
                        "spotify"
                      ),
                      [sty.byexpanded_twitter]: hasVariant(
                        $state,
                        "expanded",
                        "twitter"
                      ),
                      [sty.byexpanded_websites]: hasVariant(
                        $state,
                        "expanded",
                        "websites"
                      ),
                      [sty.byexpanded_youtube]: hasVariant(
                        $state,
                        "expanded",
                        "youtube"
                      )
                    }
                  )}
                >
                  {hasVariant($state, "expanded", "spotify")
                    ? "on:"
                    : hasVariant($state, "expanded", "youtube")
                    ? "on:"
                    : hasVariant($state, "expanded", "twitter")
                    ? "on:"
                    : hasVariant($state, "expanded", "websites")
                    ? "on:"
                    : "Published on:"}
                </div>
                <div
                  data-plasmic-name={"openOriginalLinkButtonForWebsites"}
                  data-plasmic-override={
                    overrides.openOriginalLinkButtonForWebsites
                  }
                  className={classNames(
                    projectcss.all,
                    sty.openOriginalLinkButtonForWebsites,
                    {
                      [sty.openOriginalLinkButtonForWebsitesexpanded_websites]:
                        hasVariant($state, "expanded", "websites")
                    }
                  )}
                >
                  <OriginalLinkButton
                    data-plasmic-name={"originalLinkButton"}
                    data-plasmic-override={overrides.originalLinkButton}
                    className={classNames(
                      "__wab_instance",
                      sty.originalLinkButton,
                      {
                        [sty.originalLinkButtonexpanded_spotify]: hasVariant(
                          $state,
                          "expanded",
                          "spotify"
                        ),
                        [sty.originalLinkButtonexpanded_twitter]: hasVariant(
                          $state,
                          "expanded",
                          "twitter"
                        ),
                        [sty.originalLinkButtonexpanded_websites]: hasVariant(
                          $state,
                          "expanded",
                          "websites"
                        ),
                        [sty.originalLinkButtonexpanded_youtube]: hasVariant(
                          $state,
                          "expanded",
                          "youtube"
                        )
                      }
                    )}
                    expanded={
                      hasVariant($state, "expanded", "spotify")
                        ? "websites"
                        : hasVariant($state, "expanded", "youtube")
                        ? "websites"
                        : hasVariant($state, "expanded", "twitter")
                        ? "websites"
                        : hasVariant($state, "expanded", "websites")
                        ? "websites"
                        : undefined
                    }
                    size={
                      hasVariant($state, "expanded", "twitter")
                        ? "big"
                        : hasVariant($state, "expanded", "websites")
                        ? "big"
                        : undefined
                    }
                  >
                    {hasVariant($state, "expanded", "spotify")
                      ? "View on Twitter"
                      : hasVariant($state, "expanded", "youtube")
                      ? "View on Twitter"
                      : hasVariant($state, "expanded", "twitter")
                      ? "view on Twitter"
                      : "something.com"}
                  </OriginalLinkButton>
                </div>
              </div>
            </p.Stack>
            <MenuOption
              className={classNames("__wab_instance", sty.menuOption__x3TnV, {
                [sty.menuOptionexpanded_spotify__x3TnVIn6M]: hasVariant(
                  $state,
                  "expanded",
                  "spotify"
                ),
                [sty.menuOptionexpanded_twitter__x3TnVpLf1K]: hasVariant(
                  $state,
                  "expanded",
                  "twitter"
                ),
                [sty.menuOptionexpanded_websites__x3TnVJcYhO]: hasVariant(
                  $state,
                  "expanded",
                  "websites"
                ),
                [sty.menuOptionexpanded_youtube__x3TnVcGgNx]: hasVariant(
                  $state,
                  "expanded",
                  "youtube"
                )
              })}
              icon={
                <div className={classNames(projectcss.all, sty.freeBox__buPbA)}>
                  <IconsOpenIcon
                    data-plasmic-name={"icon4"}
                    data-plasmic-override={overrides.icon4}
                    className={classNames(projectcss.all, sty.icon4)}
                    role={"img"}
                  />
                </div>
              }
              title={"Share"}
            />

            <SmallPlayButton
              data-plasmic-name={"smallPlayButton"}
              data-plasmic-override={overrides.smallPlayButton}
              className={classNames("__wab_instance", sty.smallPlayButton, {
                [sty.smallPlayButtonexpanded_spotify]: hasVariant(
                  $state,
                  "expanded",
                  "spotify"
                ),
                [sty.smallPlayButtonexpanded_twitter]: hasVariant(
                  $state,
                  "expanded",
                  "twitter"
                ),
                [sty.smallPlayButtonexpanded_websites]: hasVariant(
                  $state,
                  "expanded",
                  "websites"
                ),
                [sty.smallPlayButtonexpanded_youtube]: hasVariant(
                  $state,
                  "expanded",
                  "youtube"
                )
              })}
            />
          </p.Stack>
          {(hasVariant($state, "hideSource", "hideSource") ? false : true) ? (
            <div
              className={classNames(projectcss.all, sty.freeBox__gYdDm, {
                [sty.freeBoxexpanded_spotify__gYdDmIn6M]: hasVariant(
                  $state,
                  "expanded",
                  "spotify"
                ),
                [sty.freeBoxexpanded_twitter__gYdDmpLf1K]: hasVariant(
                  $state,
                  "expanded",
                  "twitter"
                ),
                [sty.freeBoxexpanded_websites__gYdDmJcYhO]: hasVariant(
                  $state,
                  "expanded",
                  "websites"
                ),
                [sty.freeBoxexpanded_youtube__gYdDmcGgNx]: hasVariant(
                  $state,
                  "expanded",
                  "youtube"
                ),
                [sty.freeBoxhideSource__gYdDmy5GZh]: hasVariant(
                  $state,
                  "hideSource",
                  "hideSource"
                )
              })}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__ux1Uq,
                  {
                    [sty.textexpanded_spotify__ux1UqIn6M]: hasVariant(
                      $state,
                      "expanded",
                      "spotify"
                    ),
                    [sty.textexpanded_twitter__ux1UqPLf1K]: hasVariant(
                      $state,
                      "expanded",
                      "twitter"
                    ),
                    [sty.textexpanded_websites__ux1UqJcYhO]: hasVariant(
                      $state,
                      "expanded",
                      "websites"
                    ),
                    [sty.textexpanded_youtube__ux1UqCGgNx]: hasVariant(
                      $state,
                      "expanded",
                      "youtube"
                    )
                  }
                )}
              >
                {"Source: "}
              </div>
              <Source
                data-plasmic-name={"source"}
                data-plasmic-override={overrides.source}
                baseVariant={
                  hasVariant($state, "expanded", "spotify")
                    ? "added"
                    : hasVariant($state, "expanded", "youtube")
                    ? "added"
                    : hasVariant($state, "expanded", "twitter")
                    ? "added"
                    : hasVariant($state, "expanded", "websites")
                    ? "added"
                    : "added"
                }
                className={classNames("__wab_instance", sty.source, {
                  [sty.sourceexpanded_spotify]: hasVariant(
                    $state,
                    "expanded",
                    "spotify"
                  ),
                  [sty.sourceexpanded_twitter]: hasVariant(
                    $state,
                    "expanded",
                    "twitter"
                  ),
                  [sty.sourceexpanded_websites]: hasVariant(
                    $state,
                    "expanded",
                    "websites"
                  ),
                  [sty.sourceexpanded_youtube]: hasVariant(
                    $state,
                    "expanded",
                    "youtube"
                  )
                })}
                sourceDescription={
                  <div
                    data-plasmic-name={"sourceDescription"}
                    data-plasmic-override={overrides.sourceDescription}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.sourceDescription
                    )}
                  >
                    {
                      "I love @crystale & our 3 girls. Used to invest in startups. Had fun on @ABCSharkTank. Working hard to unf**k the planet."
                    }
                  </div>
                }
                sourceHandle={
                  <div
                    data-plasmic-name={"sourceHandle"}
                    data-plasmic-override={overrides.sourceHandle}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.sourceHandle,
                      {
                        [sty.sourceHandleexpanded_spotify]: hasVariant(
                          $state,
                          "expanded",
                          "spotify"
                        ),
                        [sty.sourceHandleexpanded_twitter]: hasVariant(
                          $state,
                          "expanded",
                          "twitter"
                        ),
                        [sty.sourceHandleexpanded_websites]: hasVariant(
                          $state,
                          "expanded",
                          "websites"
                        ),
                        [sty.sourceHandleexpanded_youtube]: hasVariant(
                          $state,
                          "expanded",
                          "youtube"
                        )
                      }
                    )}
                  >
                    {"@sacca"}
                  </div>
                }
                sourceTitle={
                  <div
                    data-plasmic-name={"sourceTitle"}
                    data-plasmic-override={overrides.sourceTitle}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.sourceTitle,
                      {
                        [sty.sourceTitleexpanded_websites]: hasVariant(
                          $state,
                          "expanded",
                          "websites"
                        )
                      }
                    )}
                  >
                    {"Chris Sacca"}
                  </div>
                }
              />
            </div>
          ) : null}
          <p.Stack
            as={"div"}
            hasGap={true}
            className={classNames(projectcss.all, sty.freeBox__xnoRg, {
              [sty.freeBoxexpanded_spotify__xnoRgIn6M]: hasVariant(
                $state,
                "expanded",
                "spotify"
              ),
              [sty.freeBoxexpanded_twitter__xnoRgPLf1K]: hasVariant(
                $state,
                "expanded",
                "twitter"
              ),
              [sty.freeBoxexpanded_websites__xnoRgJcYhO]: hasVariant(
                $state,
                "expanded",
                "websites"
              ),
              [sty.freeBoxexpanded_youtube__xnoRgCGgNx]: hasVariant(
                $state,
                "expanded",
                "youtube"
              )
            })}
          >
            <MenuOption
              data-plasmic-name={"openOriginalLinkButton"}
              data-plasmic-override={overrides.openOriginalLinkButton}
              className={classNames(
                "__wab_instance",
                sty.openOriginalLinkButton,
                {
                  [sty.openOriginalLinkButtonexpanded_spotify]: hasVariant(
                    $state,
                    "expanded",
                    "spotify"
                  ),
                  [sty.openOriginalLinkButtonexpanded_twitter]: hasVariant(
                    $state,
                    "expanded",
                    "twitter"
                  ),
                  [sty.openOriginalLinkButtonexpanded_websites]: hasVariant(
                    $state,
                    "expanded",
                    "websites"
                  ),
                  [sty.openOriginalLinkButtonexpanded_youtube]: hasVariant(
                    $state,
                    "expanded",
                    "youtube"
                  )
                }
              )}
              icon={
                <div
                  className={classNames(projectcss.all, sty.freeBox__oSlMc, {
                    [sty.freeBoxexpanded_spotify__oSlMcIn6M]: hasVariant(
                      $state,
                      "expanded",
                      "spotify"
                    )
                  })}
                >
                  <p.PlasmicIcon
                    data-plasmic-name={"icon"}
                    data-plasmic-override={overrides.icon}
                    PlasmicIconType={
                      hasVariant($state, "expanded", "spotify")
                        ? SpotifyLogoIcon
                        : hasVariant($state, "expanded", "youtube")
                        ? IconsSourcesYoutubeIcon
                        : hasVariant($state, "expanded", "twitter")
                        ? _27IcontwitterIcon
                        : hasVariant($state, "expanded", "websites")
                        ? TwitterFlatIcon
                        : IconsOpenIcon
                    }
                    className={classNames(projectcss.all, sty.icon, {
                      [sty.iconexpanded_spotify]: hasVariant(
                        $state,
                        "expanded",
                        "spotify"
                      ),
                      [sty.iconexpanded_twitter]: hasVariant(
                        $state,
                        "expanded",
                        "twitter"
                      ),
                      [sty.iconexpanded_websites]: hasVariant(
                        $state,
                        "expanded",
                        "websites"
                      ),
                      [sty.iconexpanded_youtube]: hasVariant(
                        $state,
                        "expanded",
                        "youtube"
                      )
                    })}
                    role={"img"}
                  />
                </div>
              }
              noPadding={
                hasVariant($state, "expanded", "spotify")
                  ? true
                  : hasVariant($state, "expanded", "youtube")
                  ? true
                  : hasVariant($state, "expanded", "twitter")
                  ? true
                  : hasVariant($state, "expanded", "websites")
                  ? true
                  : undefined
              }
              sourceCategoryType={
                hasVariant($state, "expanded", "spotify")
                  ? "spotify"
                  : hasVariant($state, "expanded", "youtube")
                  ? "youtube"
                  : hasVariant($state, "expanded", "twitter")
                  ? "twitter"
                  : undefined
              }
              title={
                hasVariant($state, "expanded", "spotify")
                  ? "view on Spotify"
                  : hasVariant($state, "expanded", "youtube")
                  ? "watch on Youtube"
                  : hasVariant($state, "expanded", "twitter")
                  ? "open on Twitter"
                  : hasVariant($state, "expanded", "websites")
                  ? "view on Twitter"
                  : "Show more"
              }
            />

            <MenuOption
              className={classNames("__wab_instance", sty.menuOption__hOgSk, {
                [sty.menuOptionexpanded_spotify__hOgSkIn6M]: hasVariant(
                  $state,
                  "expanded",
                  "spotify"
                ),
                [sty.menuOptionexpanded_twitter__hOgSkPLf1K]: hasVariant(
                  $state,
                  "expanded",
                  "twitter"
                ),
                [sty.menuOptionexpanded_websites__hOgSkJcYhO]: hasVariant(
                  $state,
                  "expanded",
                  "websites"
                ),
                [sty.menuOptionexpanded_youtube__hOgSkCGgNx]: hasVariant(
                  $state,
                  "expanded",
                  "youtube"
                )
              })}
              icon={
                <div className={classNames(projectcss.all, sty.freeBox__yhOHd)}>
                  <p.PlasmicIcon
                    data-plasmic-name={"icon11"}
                    data-plasmic-override={overrides.icon11}
                    PlasmicIconType={
                      hasVariant($state, "expanded", "spotify")
                        ? IconsShareIcon
                        : hasVariant($state, "expanded", "youtube")
                        ? IconsShareIcon
                        : hasVariant($state, "expanded", "twitter")
                        ? IconsShareIcon
                        : hasVariant($state, "expanded", "websites")
                        ? IconsShareIcon
                        : IconsOpenIcon
                    }
                    className={classNames(projectcss.all, sty.icon11, {
                      [sty.icon11expanded_spotify]: hasVariant(
                        $state,
                        "expanded",
                        "spotify"
                      ),
                      [sty.icon11expanded_twitter]: hasVariant(
                        $state,
                        "expanded",
                        "twitter"
                      ),
                      [sty.icon11expanded_websites]: hasVariant(
                        $state,
                        "expanded",
                        "websites"
                      ),
                      [sty.icon11expanded_youtube]: hasVariant(
                        $state,
                        "expanded",
                        "youtube"
                      )
                    })}
                    role={"img"}
                  />
                </div>
              }
              noPadding={
                hasVariant($state, "expanded", "spotify")
                  ? true
                  : hasVariant($state, "expanded", "youtube")
                  ? true
                  : hasVariant($state, "expanded", "twitter")
                  ? true
                  : hasVariant($state, "expanded", "websites")
                  ? true
                  : undefined
              }
              title={
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__bkmkL,
                    {
                      [sty.textexpanded_spotify__bkmkLIn6M]: hasVariant(
                        $state,
                        "expanded",
                        "spotify"
                      ),
                      [sty.textexpanded_twitter__bkmkLpLf1K]: hasVariant(
                        $state,
                        "expanded",
                        "twitter"
                      ),
                      [sty.textexpanded_websites__bkmkLJcYhO]: hasVariant(
                        $state,
                        "expanded",
                        "websites"
                      ),
                      [sty.textexpanded_youtube__bkmkLcGgNx]: hasVariant(
                        $state,
                        "expanded",
                        "youtube"
                      )
                    }
                  )}
                >
                  {hasVariant($state, "expanded", "spotify")
                    ? "Share"
                    : hasVariant($state, "expanded", "youtube")
                    ? "Share"
                    : hasVariant($state, "expanded", "twitter")
                    ? "Share"
                    : hasVariant($state, "expanded", "websites")
                    ? "Share"
                    : "Show more"}
                </div>
              }
            />
          </p.Stack>
        </p.Stack>
        <MenuOption
          data-plasmic-name={"readAloudButton"}
          data-plasmic-override={overrides.readAloudButton}
          className={classNames("__wab_instance", sty.readAloudButton, {
            [sty.readAloudButtonexpanded_spotify]: hasVariant(
              $state,
              "expanded",
              "spotify"
            ),
            [sty.readAloudButtonexpanded_twitter]: hasVariant(
              $state,
              "expanded",
              "twitter"
            ),
            [sty.readAloudButtonexpanded_websites]: hasVariant(
              $state,
              "expanded",
              "websites"
            ),
            [sty.readAloudButtonexpanded_youtube]: hasVariant(
              $state,
              "expanded",
              "youtube"
            ),
            [sty.readAloudButtontype_spotify]: hasVariant(
              $state,
              "type",
              "spotify"
            ),
            [sty.readAloudButtontype_twitter]: hasVariant(
              $state,
              "type",
              "twitter"
            ),
            [sty.readAloudButtontype_youtube]: hasVariant(
              $state,
              "type",
              "youtube"
            )
          })}
          icon={
            <IconsReadAloudIcon
              data-plasmic-name={"icon5"}
              data-plasmic-override={overrides.icon5}
              className={classNames(projectcss.all, sty.icon5, {
                [sty.icon5expanded_spotify]: hasVariant(
                  $state,
                  "expanded",
                  "spotify"
                ),
                [sty.icon5expanded_twitter]: hasVariant(
                  $state,
                  "expanded",
                  "twitter"
                ),
                [sty.icon5expanded_websites]: hasVariant(
                  $state,
                  "expanded",
                  "websites"
                ),
                [sty.icon5expanded_youtube]: hasVariant(
                  $state,
                  "expanded",
                  "youtube"
                )
              })}
              role={"img"}
            />
          }
          title={"Read aloud"}
        />

        <MenuOption
          data-plasmic-name={"playNextButton"}
          data-plasmic-override={overrides.playNextButton}
          className={classNames("__wab_instance", sty.playNextButton, {
            [sty.playNextButtonexpanded_twitter]: hasVariant(
              $state,
              "expanded",
              "twitter"
            ),
            [sty.playNextButtontype_twitter]: hasVariant(
              $state,
              "type",
              "twitter"
            )
          })}
          icon={
            <div className={classNames(projectcss.all, sty.freeBox__jRRt)}>
              <DarkPlaylistIconNextsvgIcon
                data-plasmic-name={"icon6"}
                data-plasmic-override={overrides.icon6}
                className={classNames(projectcss.all, sty.icon6, {
                  [sty.icon6expanded_websites]: hasVariant(
                    $state,
                    "expanded",
                    "websites"
                  )
                })}
                role={"img"}
              />
            </div>
          }
          title={"Play next"}
        />

        <MenuOption
          data-plasmic-name={"playLaterButton"}
          data-plasmic-override={overrides.playLaterButton}
          className={classNames("__wab_instance", sty.playLaterButton, {
            [sty.playLaterButtonexpanded_twitter]: hasVariant(
              $state,
              "expanded",
              "twitter"
            ),
            [sty.playLaterButtontype_twitter]: hasVariant(
              $state,
              "type",
              "twitter"
            )
          })}
          icon={
            <div className={classNames(projectcss.all, sty.freeBox__ouWhi)}>
              <DarkPlaylistIconLastsvgIcon
                data-plasmic-name={"icon7"}
                data-plasmic-override={overrides.icon7}
                className={classNames(projectcss.all, sty.icon7)}
                role={"img"}
              />
            </div>
          }
          title={"Play later"}
        />

        <MenuOption
          data-plasmic-name={"saveForLaterButton"}
          data-plasmic-override={overrides.saveForLaterButton}
          className={classNames("__wab_instance", sty.saveForLaterButton, {
            [sty.saveForLaterButtonexpanded_spotify]: hasVariant(
              $state,
              "expanded",
              "spotify"
            ),
            [sty.saveForLaterButtonexpanded_twitter]: hasVariant(
              $state,
              "expanded",
              "twitter"
            ),
            [sty.saveForLaterButtonexpanded_websites]: hasVariant(
              $state,
              "expanded",
              "websites"
            ),
            [sty.saveForLaterButtonexpanded_youtube]: hasVariant(
              $state,
              "expanded",
              "youtube"
            )
          })}
          icon={
            <IconsSourcesSavedForLaterIcon
              data-plasmic-name={"icon8"}
              data-plasmic-override={overrides.icon8}
              className={classNames(projectcss.all, sty.icon8, {
                [sty.icon8expanded_spotify]: hasVariant(
                  $state,
                  "expanded",
                  "spotify"
                ),
                [sty.icon8expanded_twitter]: hasVariant(
                  $state,
                  "expanded",
                  "twitter"
                ),
                [sty.icon8expanded_websites]: hasVariant(
                  $state,
                  "expanded",
                  "websites"
                ),
                [sty.icon8expanded_youtube]: hasVariant(
                  $state,
                  "expanded",
                  "youtube"
                )
              })}
              role={"img"}
            />
          }
          title={"Save for later"}
        />

        <MenuOption
          data-plasmic-name={"archiveButton"}
          data-plasmic-override={overrides.archiveButton}
          className={classNames("__wab_instance", sty.archiveButton, {
            [sty.archiveButtonhideArchiveButton]: hasVariant(
              $state,
              "hideArchiveButton",
              "hideArchiveButton"
            )
          })}
          icon={
            <ArchiveIcon2Icon
              data-plasmic-name={"icon9"}
              data-plasmic-override={overrides.icon9}
              className={classNames(projectcss.all, sty.icon9)}
              role={"img"}
            />
          }
          title={"Archive"}
        />

        <MenuOption
          data-plasmic-name={"removeButton"}
          data-plasmic-override={overrides.removeButton}
          className={classNames("__wab_instance", sty.removeButton, {
            [sty.removeButtonexpanded_spotify]: hasVariant(
              $state,
              "expanded",
              "spotify"
            ),
            [sty.removeButtonexpanded_twitter]: hasVariant(
              $state,
              "expanded",
              "twitter"
            ),
            [sty.removeButtonexpanded_websites]: hasVariant(
              $state,
              "expanded",
              "websites"
            ),
            [sty.removeButtonexpanded_youtube]: hasVariant(
              $state,
              "expanded",
              "youtube"
            ),
            [sty.removeButtontype_youtube]: hasVariant(
              $state,
              "type",
              "youtube"
            )
          })}
          icon={
            <IconsDelete2Icon
              className={classNames(projectcss.all, sty.svg__gvI9)}
              role={"img"}
            />
          }
          title={
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__jpGuB,
                {
                  [sty.textexpanded_spotify__jpGuBIn6M]: hasVariant(
                    $state,
                    "expanded",
                    "spotify"
                  ),
                  [sty.textexpanded_twitter__jpGuBpLf1K]: hasVariant(
                    $state,
                    "expanded",
                    "twitter"
                  ),
                  [sty.textexpanded_websites__jpGuBJcYhO]: hasVariant(
                    $state,
                    "expanded",
                    "websites"
                  ),
                  [sty.textexpanded_youtube__jpGuBcGgNx]: hasVariant(
                    $state,
                    "expanded",
                    "youtube"
                  )
                }
              )}
            >
              {"Remove"}
            </div>
          }
        />
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  menuContainer: [
    "menuContainer",
    "menu",
    "showMoreButton",
    "icon3",
    "expandedStack",
    "titleContainer",
    "author",
    "date",
    "publishedDate",
    "by",
    "openOriginalLinkButtonForWebsites",
    "originalLinkButton",
    "icon4",
    "smallPlayButton",
    "source",
    "sourceTitle",
    "sourceHandle",
    "sourceDescription",
    "openOriginalLinkButton",
    "icon",
    "icon11",
    "readAloudButton",
    "icon5",
    "playNextButton",
    "icon6",
    "playLaterButton",
    "icon7",
    "saveForLaterButton",
    "icon8",
    "archiveButton",
    "icon9",
    "removeButton"
  ],
  menu: [
    "menu",
    "showMoreButton",
    "icon3",
    "expandedStack",
    "titleContainer",
    "author",
    "date",
    "publishedDate",
    "by",
    "openOriginalLinkButtonForWebsites",
    "originalLinkButton",
    "icon4",
    "smallPlayButton",
    "source",
    "sourceTitle",
    "sourceHandle",
    "sourceDescription",
    "openOriginalLinkButton",
    "icon",
    "icon11",
    "readAloudButton",
    "icon5",
    "playNextButton",
    "icon6",
    "playLaterButton",
    "icon7",
    "saveForLaterButton",
    "icon8",
    "archiveButton",
    "icon9",
    "removeButton"
  ],
  showMoreButton: ["showMoreButton", "icon3"],
  icon3: ["icon3"],
  expandedStack: [
    "expandedStack",
    "titleContainer",
    "author",
    "date",
    "publishedDate",
    "by",
    "openOriginalLinkButtonForWebsites",
    "originalLinkButton",
    "icon4",
    "smallPlayButton",
    "source",
    "sourceTitle",
    "sourceHandle",
    "sourceDescription",
    "openOriginalLinkButton",
    "icon",
    "icon11"
  ],
  titleContainer: ["titleContainer"],
  author: ["author"],
  date: ["date"],
  publishedDate: ["publishedDate"],
  by: ["by"],
  openOriginalLinkButtonForWebsites: [
    "openOriginalLinkButtonForWebsites",
    "originalLinkButton"
  ],
  originalLinkButton: ["originalLinkButton"],
  icon4: ["icon4"],
  smallPlayButton: ["smallPlayButton"],
  source: ["source", "sourceTitle", "sourceHandle", "sourceDescription"],
  sourceTitle: ["sourceTitle"],
  sourceHandle: ["sourceHandle"],
  sourceDescription: ["sourceDescription"],
  openOriginalLinkButton: ["openOriginalLinkButton", "icon"],
  icon: ["icon"],
  icon11: ["icon11"],
  readAloudButton: ["readAloudButton", "icon5"],
  icon5: ["icon5"],
  playNextButton: ["playNextButton", "icon6"],
  icon6: ["icon6"],
  playLaterButton: ["playLaterButton", "icon7"],
  icon7: ["icon7"],
  saveForLaterButton: ["saveForLaterButton", "icon8"],
  icon8: ["icon8"],
  archiveButton: ["archiveButton", "icon9"],
  icon9: ["icon9"],
  removeButton: ["removeButton"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  menuContainer: "div";
  menu: "div";
  showMoreButton: typeof MenuOption;
  icon3: "svg";
  expandedStack: "div";
  titleContainer: "div";
  author: "div";
  date: "div";
  publishedDate: "div";
  by: "div";
  openOriginalLinkButtonForWebsites: "div";
  originalLinkButton: typeof OriginalLinkButton;
  icon4: "svg";
  smallPlayButton: typeof SmallPlayButton;
  source: typeof Source;
  sourceTitle: "div";
  sourceHandle: "div";
  sourceDescription: "div";
  openOriginalLinkButton: typeof MenuOption;
  icon: "svg";
  icon11: "svg";
  readAloudButton: typeof MenuOption;
  icon5: "svg";
  playNextButton: typeof MenuOption;
  icon6: "svg";
  playLaterButton: typeof MenuOption;
  icon7: "svg";
  saveForLaterButton: typeof MenuOption;
  icon8: "svg";
  archiveButton: typeof MenuOption;
  icon9: "svg";
  removeButton: typeof MenuOption;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicContextMenu__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicContextMenu__VariantsArgs;
    args?: PlasmicContextMenu__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicContextMenu__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicContextMenu__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicContextMenu__ArgProps,
          internalVariantPropNames: PlasmicContextMenu__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicContextMenu__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "menuContainer") {
    func.displayName = "PlasmicContextMenu";
  } else {
    func.displayName = `PlasmicContextMenu.${nodeName}`;
  }
  return func;
}

export const PlasmicContextMenu = Object.assign(
  // Top-level PlasmicContextMenu renders the root element
  makeNodeComponent("menuContainer"),
  {
    // Helper components rendering sub-elements
    menu: makeNodeComponent("menu"),
    showMoreButton: makeNodeComponent("showMoreButton"),
    icon3: makeNodeComponent("icon3"),
    expandedStack: makeNodeComponent("expandedStack"),
    titleContainer: makeNodeComponent("titleContainer"),
    author: makeNodeComponent("author"),
    date: makeNodeComponent("date"),
    publishedDate: makeNodeComponent("publishedDate"),
    by: makeNodeComponent("by"),
    openOriginalLinkButtonForWebsites: makeNodeComponent(
      "openOriginalLinkButtonForWebsites"
    ),
    originalLinkButton: makeNodeComponent("originalLinkButton"),
    icon4: makeNodeComponent("icon4"),
    smallPlayButton: makeNodeComponent("smallPlayButton"),
    source: makeNodeComponent("source"),
    sourceTitle: makeNodeComponent("sourceTitle"),
    sourceHandle: makeNodeComponent("sourceHandle"),
    sourceDescription: makeNodeComponent("sourceDescription"),
    openOriginalLinkButton: makeNodeComponent("openOriginalLinkButton"),
    icon: makeNodeComponent("icon"),
    icon11: makeNodeComponent("icon11"),
    readAloudButton: makeNodeComponent("readAloudButton"),
    icon5: makeNodeComponent("icon5"),
    playNextButton: makeNodeComponent("playNextButton"),
    icon6: makeNodeComponent("icon6"),
    playLaterButton: makeNodeComponent("playLaterButton"),
    icon7: makeNodeComponent("icon7"),
    saveForLaterButton: makeNodeComponent("saveForLaterButton"),
    icon8: makeNodeComponent("icon8"),
    archiveButton: makeNodeComponent("archiveButton"),
    icon9: makeNodeComponent("icon9"),
    removeButton: makeNodeComponent("removeButton"),

    // Metadata about props expected for PlasmicContextMenu
    internalVariantProps: PlasmicContextMenu__VariantProps,
    internalArgProps: PlasmicContextMenu__ArgProps
  }
);

export default PlasmicContextMenu;
/* prettier-ignore-end */
